import ControlModel from "../../models/controlModel";
import { MODEL_CONTROL_TYPE } from "../../utils/enums";

export function createComboUrlControlModel({ ...args }) {
  return new ControlModel({
    value: args.value,
    items: args.items,
    type: MODEL_CONTROL_TYPE.comboUrl
  });
}